import React, { useEffect, useState } from 'react';
import { getFetchRequest, GET_ORDERS } from '../store/requests';
import { makeUrl } from '../constant';

const LIST_OF_STATUSES = {
    CREATED: 'Создан',
    PLACED: 'Размещен',
    PAID: 'Оплачено',
    DONE: 'Выполнен',
    CANCELLED: 'Отменен',
    AWAITING_PAYMENT: 'Ожидает оплаты',
    DELETED: 'Удален',
    SHIPPED: 'Отгружен',
    PARTIALLY_PLACED: 'Частично размещен',
    SUPPLIER_PLACED: 'Размещен',
};

const ARCHIVE_STATUSES = ['DELETED', 'SHIPPED'];

const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('ru-RU');
};

const formatCurrency = (value, currency) => {
    if (value === null || value === undefined || Number.isNaN(Number(value))) {
        return '';
    }
    const symbol = currency === 'USD' ? '$' : '₽';
    const number = Number(value);
    return `${number.toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${symbol}`;
};

const formatPercent = (value) => {
    if (value === null || value === undefined || Number.isNaN(Number(value))) {
        return '';
    }
    return `${Number(value)}%`;
};

const SalesArchiveTab = ({ isCollapsed }) => {
    const [orders, setOrders] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const loadOrders = () => {
            setIsLoading(true);
            setError(null);
            const url = makeUrl([GET_ORDERS, '?view=summary']);
            getFetchRequest(
                url,
                (response) => {
                    setOrders(response || []);
                    setIsLoading(false);
                },
                (err) => {
                    setError('Ошибка загрузки заказов: ' + (err?.message || 'Неизвестная ошибка'));
                    setIsLoading(false);
                }
            );
        };
        loadOrders();
    }, []);

    const renderRow = (order, index) => {
        const orderNumber = order.order_number ?? order.orderNumber ?? '';
        const date = formatDate(order.date_creation ?? order.dateCreation);
        const customer = order.customerName ?? order.customer_id ?? '';
        const total = formatCurrency(order.totalCost, order.currency);
        const isDeleted = order.status === 'DELETED';
        const hasRecordedPayments = order.paidAmount !== null && order.paidAmount !== undefined;
        const paidAmount = isDeleted
            ? 'Оплата не поступила'
            : (hasRecordedPayments
                ? order.paidAmount
                : (order.date_paid || order.datePaid ? order.totalCost : null));
        const paidPercent = isDeleted
            ? null
            : (hasRecordedPayments
                ? (order.paymentPercent ?? null)
                : (order.paymentPercent ?? (order.date_paid || order.datePaid ? 100 : null)));
        const datePaid = isDeleted
            ? ''
            : formatDate(
                hasRecordedPayments
                    ? (order.paymentDate ?? order.date_paid ?? order.datePaid)
                    : (order.date_paid ?? order.datePaid)
            );
        const status = LIST_OF_STATUSES[order.status] || order.status || '';
        const shippingPercent = formatPercent(order.shippingPercent);

        return (
            <div
                key={order.id || index}
                className="clients-table__row"
            >
                <div className="clients-table__cell clients-table__cell--id">{orderNumber}</div>
                <div className="clients-table__cell">{date}</div>
                <div className="clients-table__cell">{customer}</div>
                <div className="clients-table__cell">{total}</div>
                <div className={`clients-table__cell ${isDeleted ? 'clients-table__cell--danger' : ''}`}>
                    {isDeleted
                        ? 'Оплата не поступила'
                        : (paidAmount !== null && paidAmount !== undefined
                            ? formatCurrency(paidAmount, hasRecordedPayments ? 'RUB' : order.currency)
                            : '')}
                </div>
                <div className="clients-table__cell">{formatPercent(paidPercent)}</div>
                <div className="clients-table__cell">{datePaid}</div>
                <div className={`clients-table__cell ${isDeleted ? 'clients-table__cell--danger' : ''}`}>{status}</div>
                <div className="clients-table__cell">{shippingPercent}</div>
            </div>
        );
    };

    const archiveOrders = orders.filter((order) => ARCHIVE_STATUSES.includes(order?.status));

    if (isLoading) {
        return (
            <section className={`page-content ${isCollapsed === null ? '' : isCollapsed ? 'page-content_collapsed' : 'page-content_full-width'}`}>
                <div className="loading">Загрузка архива...</div>
            </section>
        );
    }

    if (error) {
        return (
            <section className={`page-content ${isCollapsed === null ? '' : isCollapsed ? 'page-content_collapsed' : 'page-content_full-width'}`}>
                <div className="error">
                    <p>{error}</p>
                </div>
            </section>
        );
    }

    return (
        <section className={`page-content ${isCollapsed === null ? '' : isCollapsed ? 'page-content_collapsed' : 'page-content_full-width'}`}>
            <article className="users">
                <div className="clients-toolbar">
                    <div className="clients-toolbar__search">
                        <input type="text" placeholder="Поиск ...." />
                        <svg className="clients-toolbar__search-icon" width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.7938 14.6615C14.6355 14.6615 17.7498 11.5473 17.7498 7.70574C17.7498 3.86419 14.6355 0.75 10.7938 0.75C6.95218 0.75 3.83789 3.86419 3.83789 7.70574C3.83789 11.5473 6.95218 14.6615 10.7938 14.6615Z" stroke="#1C1C1C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M5.87594 12.6245L0.75 17.7503" stroke="#1C1C1C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                </div>
                <div className="clients-table clients-table--archive">
                    <div className="clients-table__header">
                        <div className="clients-table__row">
                            <div className="clients-table__cell clients-table__cell--id">Номер</div>
                            <div className="clients-table__cell">Дата</div>
                            <div className="clients-table__cell">Клиент</div>
                            <div className="clients-table__cell">Сумма</div>
                            <div className="clients-table__cell">Оплачено</div>
                            <div className="clients-table__cell">% оплаты</div>
                            <div className="clients-table__cell">Дата оплаты</div>
                            <div className="clients-table__cell">Состояние заказа</div>
                            <div className="clients-table__cell">% Отгрузки</div>
                        </div>
                    </div>
                    <div className="clients-table__body">
                        {archiveOrders.length === 0 ? (
                            <div className="clients-table__row">
                                <div className="clients-table__cell" style={{ gridColumn: '1 / -1' }}>
                                    Архив пока пуст
                                </div>
                            </div>
                        ) : (
                            archiveOrders.map(renderRow)
                        )}
                    </div>
                </div>
            </article>
        </section>
    );
};

export default SalesArchiveTab;
